import type { TFunction } from "i18next";

import { statusIntent } from "@/design";
import type { IntentName } from "@/design";

import type { Lifecycle } from "./types";

// Lifecycle codes are a BE enum; the canonical mapping lives in src/design/status-taxonomy.json (Rule 11).
export function lifecycleIntent(s: Lifecycle) {
  return statusIntent("order", s);
}

// Return statuses are verbatim per-marketplace strings (not unified), so the
// intent is derived by keyword: done -> success, closed-out -> neutral, else pending.
const RETURN_DONE = ["COMPLETE", "SUCCESS", "ACCEPTED", "RETURNED"];
const RETURN_CLOSED = ["CANCEL", "REJECT", "CLOSED"];

export function returnIntent(status: string): IntentName {
  const s = status.toUpperCase();
  if (RETURN_CLOSED.some((k) => s.includes(k))) return "neutral";
  if (RETURN_DONE.some((k) => s.includes(k))) return "success";
  return "warning";
}

// Raw per-marketplace code -> human label. Known codes live in i18n
// (orders:return_status_label.*); unknown codes fall back to "Some new status".
export function returnStatusLabel(status: string, t: TFunction<"orders">): string {
  const readable = status.toLowerCase().replace(/_/g, " ");
  return t(`return_status_label.${status.toUpperCase()}`, {
    defaultValue: readable.charAt(0).toUpperCase() + readable.slice(1),
  });
}

// Canonical fulfillment flow. Single source of truth for the Timeline component.
export const STATUS_FLOW: Lifecycle[] = [
  "received",
  "reserved",
  "picked",
  "packed",
  "shipped",
  "delivered",
];

// (mapChannelToFlow/CHANNEL_TO_FLOW removed — Lifecycle now genuinely advances
// through picked/packed/shipped/delivered, so Timeline.tsx no longer needs a
// channel-status lookahead. See docs/superpowers/specs/2026-07-13-order-status-three-way-split-design.md §2.)
